module.exports = __webpack_public_path__ + "static/media/MaskGroup19.73de1eeb.svg";